import { render, staticRenderFns } from "./DataTableInfo.vue?vue&type=template&id=9c01f68a&"
import script from "./DataTableInfo.vue?vue&type=script&lang=js&"
export * from "./DataTableInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports